import { IAction } from '~/src/store';

import { ECitySelect } from './index';

export type TCloseCitySelect = IAction<ECitySelect.CLOSE_CITYSELECT, null>

const closeCitySelect = (): TCloseCitySelect => ({
    type: ECitySelect.CLOSE_CITYSELECT,
    payload: null,
});

export default closeCitySelect;
